import { FC } from "react";
import AssignKVSDocumentsSvg from "../../public/icons/AssignKVSDocuments.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const AssignGeometryByKvsDocumentIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><AssignKVSDocumentsSvg/></span>;
